/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import {
    Heading,
    FlexRow,
    FlexCol,
    ContentContainerBodyShift,
    TextBlock,
    Text,
} from 'sarsaparilla';

const linkItems = [
    {
        title: 'Choose Your Forest',
        description:
            'Determine which participating forest works best for your Christmas tree outing. Each forest will have specific guidelines and season dates for cutting a Christmas tree.',
        icon: 'ico1.svg',
    },
    {
        title: 'Get the Details',
        description:
            'Be safe and prepared. Carefully read the details and rules of your permit, and follow the Need to Know suggestions to prepare for your visit.',
        icon: 'ico2.svg',
    },
    {
        title: 'Buy a Permit',
        description:
            'Purchase and print your permit so you’re ready to find your perfect Christmas tree.',
        icon: 'ico3.svg',
    },
];

export default function HowItWorks() {
    return (
        <section
            className="tree-permit-how-it-works-container"
            aria-labelledby="tree-permit-how-it-works-heading"
        >
            <ContentContainerBodyShift>
                <FlexRow>
                    <FlexCol xs={12}>
                        <Heading
                            headingLevel={2}
                            appearance="h4"
                            hasUnderline="left"
                            className="mb-1"
                            id="tree-permit-how-it-works-heading"
                        >
                            How It Works
                        </Heading>
                    </FlexCol>

                    <FlexCol className="tree-permit-how-it-works-intro-text">
                        <TextBlock width="lg">
                            <Text size="lg" color="gray" className="mb-3">
                                Purchase your Christmas tree permit in advance of your
                                visit to the forest in your area. Use this site to
                                purchase your permit, follow tips and guidelines for the
                                cutting area, and ensure you are prepared for a safe and
                                fun forest adventure.
                            </Text>
                        </TextBlock>
                    </FlexCol>
                </FlexRow>
                <FlexRow alignItems="center">
                    <FlexCol xs={12} lg={6} xl={5}>
                        <picture>
                            <source
                                media="(max-width: 992px)"
                                srcSet={`${process.env.CDN}/img/where-to-cut-sm.jpg`}
                            />
                            <img
                                className="tree-permit-how-it-works-image"
                                src={`${process.env.CDN}/img/where-to-cut.jpg`}
                                alt="A person in a blue snow jacket cuts a Christmas tree in the snow"
                            />
                        </picture>
                    </FlexCol>
                    <FlexCol className="tree-permit-how-it-works-facts">
                        {linkItems.map((linkItem) => (
                            <FlexRow
                                key={linkItem.title}
                                hasGutters={false}
                                className="tree-permit-how-it-works-fact"
                            >
                                <FlexCol xs="variable" className="mr-2">
                                    <img
                                        src={`${process.env.CDN}/img/${linkItem.icon}`}
                                        alt=""
                                        className="tree-permit-how-it-works-icon"
                                    />
                                </FlexCol>
                                <FlexCol xs="auto">
                                    <Heading
                                        headingLevel={3}
                                        appearance="h5"
                                        className="mb-half"
                                    >
                                        {linkItem.title}
                                    </Heading>
                                    <Text
                                        size="lg"
                                        color="gray"
                                        className="tree-permit-how-it-works-fact-text"
                                    >
                                        {linkItem.description}
                                    </Text>
                                </FlexCol>
                            </FlexRow>
                        ))}
                    </FlexCol>
                </FlexRow>
            </ContentContainerBodyShift>
        </section>
    );
}
